import { Box, Button, TextField, Typography, MenuItem } from '@mui/material'
import { useState } from 'react'
import { useApi } from '../../api'
import { useNavigate } from 'react-router-dom'

export default function LoginPage() {
   const { post } = useApi()
   const navigate = useNavigate()

   const [payload, setPayload] = useState({
      username: '',
      password: '',
      role: 'proctor',
   })

   const handleLogin = async (payload) => {
      try {
         const res = await post('/login', payload)
         sessionStorage.setItem('token', res.token)

         alert('Login success')

         switch (payload?.role) {
            case 'admin':
               navigate('/admin/dashboard')
               break
            case 'institution':
               navigate('/institution/dashboard')
               break
            case 'proctor':
               navigate('/proctor/dashboard')
               break
            case 'exam':
               navigate('/exam/exam-room')
               break
            default:
               navigate('/')
               break
         }
      } catch (err) {
         console.error(err)
         alert(err.response?.data?.message || 'Login failed')
      }
   }

   return (
      <Box
         sx={{
            width: 300,
            mx: 'auto',
            mt: 10,
            display: 'flex',
            flexDirection: 'column',
            gap: 2,
         }}
      >
         <Typography variant="h5" align="center">
            Login
         </Typography>
         <TextField
            label="Username"
            onChange={(e) =>
               setPayload({ ...payload, username: e.target.value })
            }
            variant="outlined"
         />
         <TextField
            label="Password"
            onChange={(e) =>
               setPayload({ ...payload, password: e.target.value })
            }
            variant="outlined"
            type="password"
         />
         <TextField
            select
            label="Role"
            value={payload?.role || ''}
            onChange={(e) => setPayload({ ...payload, role: e.target.value })}
            disabled
         >
            <MenuItem value="admin">Admin</MenuItem>
            <MenuItem value="institution">Institution</MenuItem>
            <MenuItem value="proctor">Proctor</MenuItem>
            <MenuItem value="exam">Exam</MenuItem>
         </TextField>
         <Button
            variant="contained"
            onClick={() => handleLogin(payload)}
            disabled={
               !payload ||
               !payload?.username ||
               !payload?.password ||
               !payload?.role
            }
         >
            Login
         </Button>
      </Box>
   )
}
